(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kik-image-with-text"] && !Shopify.designMode) return;
  try {
    
  // Minimal accessibility: ensure image role is announced when image is present
  (function(){ 
    var s = document.currentScript.closest('[data-section-id]');
    if(!s) return; 
  })();

  } catch(e) { console.error(e); }
})();
})();
